import PropTypes from "prop-types";
import { InputNumber, Select } from "top-component-library";
import { WizardFieldRow } from "../styles";

const OrderRateLimitTagLimitsStep = ({
  availableThrottleSettings,
  rateLimitedTag,
  maxPerDesiredTime,
  maxPerDay,
  maxBetweenStartAndEnd,
  onChangeTag,
  onChangeMaxPerDesiredTime,
  onChangeMaxPerDay,
  onChangeMaxBetweenStartAndEnd,
}) => (
  <div>
    <h4>Tag Limit: (0 means unlimited)</h4>
    <WizardFieldRow>
      <div>
        <label htmlFor="rate-limited-tag">Item Tag to Limit</label>
        <Select
          id="rate-limited-tag"
          options={availableThrottleSettings.map((tag) => ({ value: tag.name, label: tag.display_name }))}
          value={rateLimitedTag || undefined}
          onChange={onChangeTag}
        />
      </div>
      <div>
        <label htmlFor="max-per-timeblock">Max per timeblock</label>
        <InputNumber
          id="max-per-timeblock"
          min={0}
          max={10000}
          value={maxPerDesiredTime ?? 0}
          onChange={onChangeMaxPerDesiredTime}
        />
      </div>
      <div>
        <label htmlFor="max-per-day">Max per day</label>
        <InputNumber id="max-per-day" min={0} max={10000} value={maxPerDay ?? 0} onChange={onChangeMaxPerDay} />
      </div>
      <div>
        <label htmlFor="max-between-start-and-end">
          Max overall (across all days). Must select a start and end date to use this limit.
        </label>
        <InputNumber
          id="max-between-start-and-end"
          min={0}
          max={10000}
          value={maxBetweenStartAndEnd ?? 0}
          onChange={onChangeMaxBetweenStartAndEnd}
        />
      </div>
    </WizardFieldRow>
  </div>
);

OrderRateLimitTagLimitsStep.propTypes = {
  availableThrottleSettings: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string.isRequired, display_name: PropTypes.string.isRequired })
  ).isRequired,
  rateLimitedTag: PropTypes.string.isRequired,
  maxPerDesiredTime: PropTypes.number,
  maxPerDay: PropTypes.number,
  maxBetweenStartAndEnd: PropTypes.number,
  onChangeTag: PropTypes.func.isRequired,
  onChangeMaxPerDesiredTime: PropTypes.func.isRequired,
  onChangeMaxPerDay: PropTypes.func.isRequired,
  onChangeMaxBetweenStartAndEnd: PropTypes.func.isRequired,
};

OrderRateLimitTagLimitsStep.defaultProps = {
  maxPerDesiredTime: null,
  maxPerDay: null,
  maxBetweenStartAndEnd: null,
};

export default OrderRateLimitTagLimitsStep;
